import {
	ChangeDetectionStrategy,
	Component,
	ElementRef,
	Input,
	QueryList
} from '@angular/core';
import { CdkStepper } from '@angular/cdk/stepper';
import { GoStepComponent } from './go-step/go-step.component';
import { TranslateService } from '@ngx-translate/core';

@Component({
	selector: 'go-stepper',
	templateUrl: './go-stepper.component.html',
	styleUrls: ['./go-stepper.component.scss'],
	changeDetection: ChangeDetectionStrategy.OnPush,
	providers: [{
		provide: CdkStepper, useExisting: GoStepperComponent
	}],
	standalone: false
})
export class GoStepperComponent extends CdkStepper {
	@Input()
	public goStepperClass = '';
	public hideWrapper: boolean;
	public readonly steps: QueryList<GoStepComponent>;

	constructor (
		private translate: TranslateService,
		private elementRef: ElementRef<HTMLElement>
	) {
		super();
	}

	public get hideStepsIndicator (): boolean {
		return (this.selected as GoStepComponent)?.hideIndicator;
	}

	public get visibleStepsCount (): number {
		return this.elementRef.nativeElement.querySelectorAll('.step:not(.hide)').length;
	}

	public get activeStepsCount (): number {
		const activeVisibleStepsCount = this.elementRef.nativeElement
			.querySelectorAll('.step.is-active:not(.hide)')
			.length;

		return Math.max(activeVisibleStepsCount, 0);
	}

	public get stepAnnouncement (): string {
		return this.translate.instant('sign-up-stepper-announcement', {
			currentStep: this.activeStepsCount,
			allSteps: this.visibleStepsCount
		});
	}

	public isSelected (stepIndex: number) {
		return this.selectedIndex >= stepIndex;
	}
}
